import { cx } from "@emotion/css";
import LockIcon from "@mui/icons-material/Lock";
import { InputLabel } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import type { SelectChangeEvent } from "@mui/material/Select";
import MuiSelect, { type SelectProps } from "@mui/material/Select";
import type { ReactNode } from "react";
import isMobile from "src/helpers/isMobile";

import { FormControl } from "./TextField";

export const Select = ({
	children,
	className,
	...props
}: SelectProps & { placeholder?: string }) => {
	return (
		<MuiSelect
			displayEmpty
			className={cx("select--grey", className)}
			renderValue={(value) => {
				if (!value && props.placeholder) {
					return <span className="text-grey">{props.placeholder}</span>;
				}

				return value as ReactNode;
			}}
			{...props}
		>
			{children}
		</MuiSelect>
	);
};

interface SelectOption {
	id: string | number;
	[key: string]: unknown;
}

interface LEKSelectProps {
	options: SelectOption[];
	value?: string | number;
	onChange: (event: SelectChangeEvent<unknown>) => void;
	title?: string;
	disabled?: boolean;
	size?: "small" | "medium";
	optionKey: string;
	disabledList?: SelectOption[];
}

function LEKSelect(props: LEKSelectProps) {
	const isDisabled = (option: SelectOption) => {
		if (!props.disabledList) {
			return false;
		}

		return props.disabledList.some((element) => element.id === option.id);
	};

	const renderIcon = (option: SelectOption) => {
		if (!props.disabledList || !isDisabled(option)) {
			return null;
		}

		return (
			<ListItemIcon>
				<LockIcon fontSize="small" color="error" />
			</ListItemIcon>
		);
	};

	if (props.options.length === 0) {
		return null;
	}

	return (
		<FormControl
			variant="outlined"
			fullWidth
			disabled={props.disabled}
			size={props.size || "medium"}
			className="select"
		>
			<InputLabel className="text-grey">{props.title}</InputLabel>
			<MuiSelect
				variant="outlined"
				className="text-field select"
				label="specializacja"
				labelId={props.title}
				native={isMobile()}
				value={props.value}
				onChange={(e) => props.onChange(e as SelectChangeEvent<unknown>)}
			>
				{props.options.map((option) =>
					isMobile() ? (
						<option
							disabled={isDisabled(option)}
							key={option[props.optionKey] as string}
							value={option.id}
						>
							{option[props.optionKey] as string}
						</option>
					) : (
						<MenuItem
							className="wb-break-word ws-unset"
							disabled={isDisabled(option)}
							key={option[props.optionKey] as string}
							value={option.id}
						>
							{renderIcon(option)}
							<ListItemText className="text-black">
								{option[props.optionKey] as string}
							</ListItemText>
						</MenuItem>
					),
				)}
			</MuiSelect>
		</FormControl>
	);
}

export default LEKSelect;
